export enum TransportationAttributeGroup {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export enum TransportationAttributeSubgrouping {
  ADDITIONALPASSENGER = 'additionalpassenger',
  OTHER = 'other',
}

export interface TransportationAttribute {
  transportationAttributeUUID?: string;
  transportationAttributeCategoryBC: string;
  name: string;
  description: string;
  isPassengerSelectable: boolean;
  isDefault: boolean;
  state?: string;
  childTransportationAttributeCategoryBC?: string;
  grouping?: TransportationAttributeGroup;
  subgrouping?: TransportationAttributeSubgrouping;
  displayOrder?: number;
  passengerCareLevelBC?: string;
  tripModeBC?: string;
}
